export enum CursorFunction {
    ZOOM = 'zoom',
    SELECT = 'select',
}
